var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnProfile2User = function SvgIcnProfile2User(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7162 19C16.5811 18.9865 16.4189 18.9865 16.2703 19C13.0541 18.8918 10.5 16.2537 10.5 13.0068C10.5 9.69222 13.1757 7 16.5 7C19.8108 7 22.5 9.69222 22.5 13.0068C22.4865 16.2537 19.9324 18.8918 16.7162 19Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6432 10C28.781 10 30.5 12.0186 30.5 14.5C30.5 16.93 28.8471 18.91 26.7865 19C26.6983 18.9871 26.5992 18.9871 26.5 19",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89516 23.9101C6.70161 26.1647 6.70161 29.8388 9.89516 32.0794C13.5242 34.6402 19.4758 34.6402 23.1048 32.0794C26.2984 29.8249 26.2984 26.1508 23.1048 23.9101C19.489 21.3633 13.5374 21.3633 9.89516 23.9101Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 31C29.4201 30.8 30.2891 30.4133 31.0048 29.84C32.9984 28.28 32.9984 25.7067 31.0048 24.1467C30.3019 23.5867 29.4457 23.2133 28.5383 23",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnProfile2User, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_profile_2user.db03a0e1.svg";
export { ForwardRef as ReactComponent };